<template>
    <LayoutWrapper :id="id">
        <LayoutPaddingSpace>
            <LayoutContainer>
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.searchParameters') }}
                    </SectionTitle>
                    <SectionBlock>
                        <MultiSubjectLengthField v-if="store.isMultiDbType" />
                        <SubjectLengthField v-else />
                        <MaxTargetSequenceField :limit-options="limitOptions" />
                    </SectionBlock>
                </LayoutColumn>
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.algorithmSettings') }}
                    </SectionTitle>
                    <SectionBlock>
                        <MatchWithGapsField />
                        <EvalueField />
                        <LowComplexRegionField />
                    </SectionBlock>
                </LayoutColumn>
            </LayoutContainer>
            <Collapse v-model="proxyExpand">
                <span slot="label">{{ $t('Search.labels.nonShortSequence') }}</span>
                <LayoutContainer>
                    <LayoutColumn>
                        <SectionBlock>
                            <AlignmentIdentityField />
                            <QueryIdentityField />
                            <QueryCoverageField />
                            <SubjectIdentityField />
                            <SubjectCoverageField />
                        </SectionBlock>
                    </LayoutColumn>
                    <LayoutColumn>
                        <AlgorithmBlock v-if="!store.algorithmSettingsDisabled" />
                    </LayoutColumn>
                </LayoutContainer>
            </Collapse>
            <slot />
        </LayoutPaddingSpace>
        <ResetSection />
    </LayoutWrapper>
</template>

<script>
import map from 'lodash/map';
import assign from 'lodash/assign';
import includes from 'lodash/includes';
import BioSearchSettingProvider from '../BioSearchSettingProvider.vue';
import AlgorithmBlock from './Algorithm.prefab.vue';
import { SEQUENCE_LIMIT_OPTIONS } from '../constants/constantConfig';

// PBI-8323 后的常规检索和短序列检索合并，相当于一个设置中包含了两种检索类型
// 这里short的几项单独设置，视觉上附属于这个面板
export default {
    components: {
        AlgorithmBlock,
    },
    extends: BioSearchSettingProvider,
    inject: {
        state: {
            from: 'state',
            default: null,
        },
    },
    data() {
        return {
            expand: false,
        };
    },
    computed: {
        proxyExpand: {
            get() {
                if (this.state) {
                    return this.state?.manualExpand;
                }
                return this.expand;
            },
            set(val) {
                if (this.state) {
                    this.state.manualExpand = val;
                }
                this.expand = val;
            },
        },
        proxyAmountLimit() {
            if (this.state && 'amountLimit' in this.state) {
                return this.state.amountLimit;
            }
            return false;
        },
        limitOptions() {
            const options = map(SEQUENCE_LIMIT_OPTIONS, (opt) => assign(
                { ...opt },
                opt.tooltip ? { tooltip: this.$tc(opt.tooltip) } : {},
                includes([50000, 1000000], opt.value) && this.proxyAmountLimit && !this.isCnRegion
                    ? {
                        disabled: true,
                        tooltip: this.$tc(
                            'Search.labels.targetSeqLimitTooltip',
                        ),
                    } : {},
            ));
            // CN环境下，无权限时直接过滤掉
            if (this.isCnRegion) {
                return options.filter(opt => !(includes([50000, 1000000], opt.value) && this.proxyAmountLimit));
            }
            return options;
        },
    },
};
</script>
